import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7c3806a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminCompetitions" }
const _hoisted_2 = { id: "showcompetitions" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--space-around" }
const _hoisted_6 = { class: "md1 flex" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { class: "md2 flex" }
const _hoisted_11 = { class: "md3 flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Opret nyt stævne")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_15 = {
  class: "va-table va-table--striped competitionstable",
  style: {"width":"100%"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Klassement", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultater", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = ["id"]
const _hoisted_26 = ["id"]
const _hoisted_27 = ["id"]
const _hoisted_28 = ["id"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Rediger")
const _hoisted_30 = ["id"]
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_33 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_35 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_36 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_38 = { class: "selectPageSize" }
const _hoisted_39 = { class: "display-6 center" }
const _hoisted_40 = { class: "layout gutter--md" }
const _hoisted_41 = { class: "row justify--center align--center" }
const _hoisted_42 = { class: "flex md8" }
const _hoisted_43 = { class: "flex md4" }
const _hoisted_44 = { class: "row justify--start align--center" }
const _hoisted_45 = { class: "flex md4" }
const _hoisted_46 = { class: "row justify--center align--center" }
const _hoisted_47 = { class: "flex md6" }
const _hoisted_48 = { class: "flex md6" }
const _hoisted_49 = { class: "row justify--center align--center" }
const _hoisted_50 = { class: "flex md6" }
const _hoisted_51 = { class: "flex md6 center" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "invitationlabel" }, "Invitationer", -1))
const _hoisted_53 = { class: "md1 flex" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "md1 flex" }
const _hoisted_57 = { class: "md8 flex" }
const _hoisted_58 = { class: "md1 flex" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Tilføj invitation")
const _hoisted_61 = { class: "row justify--center align--center" }
const _hoisted_62 = { class: "flex md3" }
const _hoisted_63 = { class: "flex md3" }
const _hoisted_64 = { class: "flex md3" }
const _hoisted_65 = { class: "flex md3" }
const _hoisted_66 = { class: "row justify--center align--center" }
const _hoisted_67 = { class: "flex md6" }
const _hoisted_68 = { class: "flex md6" }
const _hoisted_69 = { class: "row justify--center align--center" }
const _hoisted_70 = { class: "flex md6" }
const _hoisted_71 = { class: "flex md6" }
const _hoisted_72 = { class: "row justify--center" }
const _hoisted_73 = { class: "flex md12" }
const _hoisted_74 = { class: "flex md4" }
const _hoisted_75 = { class: "flex md2" }
const _hoisted_76 = {
  class: "flex md6",
  style: {"display":"flex"}
}
const _hoisted_77 = /*#__PURE__*/_createTextVNode("SetEvent")
const _hoisted_78 = { class: "row justify--center" }
const _hoisted_79 = {
  class: "flex md12",
  style: {"display":"flex"}
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode("SetTournament")
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "* Hvis feltet efterlades blankt, så bruges dagsdato")
], -1))
const _hoisted_82 = { class: "row justify--center align--center" }
const _hoisted_83 = { class: "flex" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette stævnet?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "NB:"),
        /*#__PURE__*/_createTextVNode(" Det er ikke muligt at slette stævner, hvor der er kommet resultater")
      ])
    ])
  ])
], -1))
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_88 = { class: "invitationmodal" }
const _hoisted_89 = { class: "invitationflexbox" }
const _hoisted_90 = { class: "invitationradio" }
const _hoisted_91 = ["id", "value"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload ny invitation")
], -1))
const _hoisted_93 = { class: "uploadSection mb-4" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("Upload ny pdf")
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Tilføj valgte invitation")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_97 = {
  class: "editcompetitionResultsModal",
  style: {"flex":"1 0 auto"}
}
const _hoisted_98 = { class: "md12 flex" }
const _hoisted_99 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = { class: "row justify--center competitionResultsModal" }
const _hoisted_102 = { class: "md6 flex" }
const _hoisted_103 = { class: "row justify--center competitionResultsModal" }
const _hoisted_104 = { class: "flex md6" }
const _hoisted_105 = { class: "row justify--center competitionResultsModal" }
const _hoisted_106 = { class: "md6 flex" }
const _hoisted_107 = { class: "row justify--center competitionResultsModal" }
const _hoisted_108 = { class: "flex md6" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Indlæs en CSV-fil", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = {
  key: 0,
  class: "va-table-responsive"
}
const _hoisted_112 = {
  class: "va-table competitionresultstable",
  style: {"width":"100%"}
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Klub / land"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Licens"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Antal points"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_114 = ["hidden"]
const _hoisted_115 = ["id"]
const _hoisted_116 = ["id"]
const _hoisted_117 = ["id"]
const _hoisted_118 = ["id"]
const _hoisted_119 = ["id"]
const _hoisted_120 = ["id"]
const _hoisted_121 = ["id"]
const _hoisted_122 = ["id"]
const _hoisted_123 = ["id"]
const _hoisted_124 = ["id"]
const _hoisted_125 = ["id"]
const _hoisted_126 = ["id"]
const _hoisted_127 = ["id"]
const _hoisted_128 = ["id"]
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Nedsæt points")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("Gendan points")
const _hoisted_131 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_132 = {
  class: "va-table competitionresultstable",
  style: {"width":"100%"}
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Licens"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Antal points"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_134 = ["hidden"]
const _hoisted_135 = ["id"]
const _hoisted_136 = ["id"]
const _hoisted_137 = ["id"]
const _hoisted_138 = ["id"]
const _hoisted_139 = ["id"]
const _hoisted_140 = /*#__PURE__*/_createTextVNode("Nedsæt points")
const _hoisted_141 = /*#__PURE__*/_createTextVNode("Gendan points")
const _hoisted_142 = /*#__PURE__*/_createTextVNode("Næste")
const _hoisted_143 = /*#__PURE__*/_createTextVNode("GenerateResults")
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Gem / Opdater")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("GenerateResults")
const _hoisted_146 = /*#__PURE__*/_createTextVNode("Gem / Opdater DartConnect")
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_148 = { class: "tabHeight" }
const _hoisted_149 = { class: "row align--baseline justify--space-around" }
const _hoisted_150 = { class: "md1 flex" }
const _hoisted_151 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_152 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_153 = { class: "md2 flex" }
const _hoisted_154 = { class: "md2 flex" }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("Vis liste med alle rækker")
const _hoisted_156 = { key: 0 }
const _hoisted_157 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_158 = {
  class: "va-table va-table--striped competitionrowstable",
  style: {"width":"100%"}
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Spillested", -1))
const _hoisted_161 = ["id"]
const _hoisted_162 = ["id"]
const _hoisted_163 = ["id"]
const _hoisted_164 = ["id"]
const _hoisted_165 = ["id"]
const _hoisted_166 = ["id"]
const _hoisted_167 = ["id"]
const _hoisted_168 = ["id"]
const _hoisted_169 = ["id"]
const _hoisted_170 = ["id"]
const _hoisted_171 = ["id"]
const _hoisted_172 = ["id"]
const _hoisted_173 = ["id"]
const _hoisted_174 = ["id"]
const _hoisted_175 = ["id"]
const _hoisted_176 = ["id"]
const _hoisted_177 = ["id"]
const _hoisted_178 = { class: "tabHeight" }
const _hoisted_179 = { class: "row align--baseline justify--start" }
const _hoisted_180 = { class: "md5 flex" }
const _hoisted_181 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_182 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_183 = { class: "md2 flex" }
const _hoisted_184 = { key: 0 }
const _hoisted_185 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_186 = {
  class: "va-table--striped competitionstable",
  style: {"width":"100%"}
}
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævnekategori"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Points"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Række"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_188 = ["id"]
const _hoisted_189 = ["id"]
const _hoisted_190 = ["id"]
const _hoisted_191 = ["id"]
const _hoisted_192 = ["id"]
const _hoisted_193 = ["id"]
const _hoisted_194 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_195 = { class: "editcompetitionRankingsPointModal" }
const _hoisted_196 = { class: "md12 flex" }
const _hoisted_197 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_198 = { class: "row justify--center competitionRankingsPointModal" }
const _hoisted_199 = { class: "md6 flex" }
const _hoisted_200 = { class: "row justify--center competitionRankingsPointModal" }
const _hoisted_201 = { class: "md6 flex" }
const _hoisted_202 = { class: "flex md6" }
const _hoisted_203 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_204 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_205 = { class: "tabHeight" }
const _hoisted_206 = { id: "newcompetitionrows" }
const _hoisted_207 = { key: 0 }
const _hoisted_208 = {
  key: 1,
  class: "form createnewseriesform"
}
const _hoisted_209 = { key: 0 }
const _hoisted_210 = { class: "competitionrowform-group" }
const _hoisted_211 = { class: "layout gutter--xl" }
const _hoisted_212 = { class: "row" }
const _hoisted_213 = {
  class: "md6 flex",
  hidden: ""
}
const _hoisted_214 = { class: "row justify--space-around" }
const _hoisted_215 = { class: "md8 flex" }
const _hoisted_216 = { class: "md4 flex" }
const _hoisted_217 = { class: "row justify--space-around" }
const _hoisted_218 = { class: "md6 flex" }
const _hoisted_219 = { class: "md4 flex" }
const _hoisted_220 = /*#__PURE__*/_createTextVNode("Vis eksisterende stævnerækker")
const _hoisted_221 = { class: "row justify--center" }
const _hoisted_222 = { class: "flex" }
const _hoisted_223 = /*#__PURE__*/_createTextVNode("Opret stævnerække")
const _hoisted_224 = { class: "tabHeight" }
const _hoisted_225 = { class: "row align--center justify--start mb-4 flex-nowrap" }
const _hoisted_226 = { class: "md3 flex ml-4" }
const _hoisted_227 = { class: "md2 flex ml-4" }
const _hoisted_228 = { class: "md2 flex ml-4" }
const _hoisted_229 = /*#__PURE__*/_createTextVNode("Tilmeld / afmeld spiller")
const _hoisted_230 = { class: "md2 flex ml-4" }
const _hoisted_231 = /*#__PURE__*/_createTextVNode("Eksporter tilmeldinger")
const _hoisted_232 = { class: "md2 flex ml-4" }
const _hoisted_233 = /*#__PURE__*/_createTextVNode("Eksporter DartConnect")
const _hoisted_234 = { class: "md2 flex ml-4" }
const _hoisted_235 = /*#__PURE__*/_createTextVNode("Register to DartConnect")
const _hoisted_236 = { key: 0 }
const _hoisted_237 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_238 = {
  key: 0,
  class: "va-table--striped va-table competitionregistrationstable",
  style: {"width":"100%"}
}
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Tilmeldte"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævnerække"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_240 = ["id"]
const _hoisted_241 = ["id"]
const _hoisted_242 = ["id"]
const _hoisted_243 = ["id"]
const _hoisted_244 = ["id"]
const _hoisted_245 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette tilmeldingen?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_247 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_248 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center" }, "Tilmeld eller fjern spiller", -1))
const _hoisted_250 = { key: 0 }
const _hoisted_251 = { class: "layout gutter--xl" }
const _hoisted_252 = { class: "row justify--center" }
const _hoisted_253 = { class: "md3 flex" }
const _hoisted_254 = { class: "md9 flex" }
const _hoisted_255 = { class: "row justify--center" }
const _hoisted_256 = { class: "md12 flex" }
const _hoisted_257 = {
  key: 0,
  class: "size"
}
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Vælg først stævnerække", -1))
const _hoisted_259 = [
  _hoisted_258
]
const _hoisted_260 = {
  key: 1,
  class: "size"
}
const _hoisted_261 = {
  key: 0,
  class: "center"
}
const _hoisted_262 = {
  key: 1,
  class: "center"
}
const _hoisted_263 = { class: "row justify--center align--center" }
const _hoisted_264 = { class: "md4 flex" }
const _hoisted_265 = ["hidden"]
const _hoisted_266 = /*#__PURE__*/_createTextVNode(" Spiller(e), der skal ")
const _hoisted_267 = { key: 0 }
const _hoisted_268 = { key: 1 }
const _hoisted_269 = /*#__PURE__*/_createTextVNode(", er: ")
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_272 = { class: "row justify--center" }
const _hoisted_273 = { class: "flex md6" }
const _hoisted_274 = { class: "flex md6" }
const _hoisted_275 = /*#__PURE__*/_createTextVNode("Tilføj spiller(e)")
const _hoisted_276 = /*#__PURE__*/_createTextVNode("Fjern spiller(e)")
const _hoisted_277 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_278 = { class: "tabHeight" }
const _hoisted_279 = { class: "row align--center justify--start mb-2" }
const _hoisted_280 = { class: "md3 flex ml-4" }
const _hoisted_281 = { class: "md2 flex ml-4" }
const _hoisted_282 = { class: "md2 flex ml-4" }
const _hoisted_283 = { class: "md2 flex ml-4" }
const _hoisted_284 = /*#__PURE__*/_createTextVNode("Tilføj udenlandske resultater")
const _hoisted_285 = { class: "row align--center justify--start" }
const _hoisted_286 = { class: "flex md4 ml-4" }
const _hoisted_287 = { key: 0 }
const _hoisted_288 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_289 = {
  class: "va-table va-table--striped competitionresultstable",
  style: {"width":"100%"}
}
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Spiller"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævne"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævnerække"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultat dato"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Points"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger")
  ])
], -1))
const _hoisted_291 = { key: 0 }
const _hoisted_292 = ["id"]
const _hoisted_293 = ["id"]
const _hoisted_294 = ["id"]
const _hoisted_295 = ["id"]
const _hoisted_296 = ["id"]
const _hoisted_297 = ["id"]
const _hoisted_298 = ["id"]
const _hoisted_299 = ["id"]
const _hoisted_300 = ["id"]
const _hoisted_301 = /*#__PURE__*/_createTextVNode("Nedsæt points")
const _hoisted_302 = /*#__PURE__*/_createTextVNode("Gendan points")
const _hoisted_303 = { key: 1 }
const _hoisted_304 = ["id"]
const _hoisted_305 = ["id"]
const _hoisted_306 = ["id"]
const _hoisted_307 = ["id"]
const _hoisted_308 = ["id"]
const _hoisted_309 = ["id"]
const _hoisted_310 = ["id"]
const _hoisted_311 = ["id"]
const _hoisted_312 = { class: "center" }
const _hoisted_313 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "size" }, "Er du sikker på at du vil slette dette resultat")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_315 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_316 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_317 = { class: "layout gutter--xl" }
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Tilføj og rediger udenlandske resultater", -1))
const _hoisted_319 = { class: "row align--center" }
const _hoisted_320 = {
  class: "flex md4",
  style: {"display":"flex"}
}
const _hoisted_321 = { class: "flex md3" }
const _hoisted_322 = { class: "flex md5" }
const _hoisted_323 = { class: "row justify--center" }
const _hoisted_324 = { class: "flex md4" }
const _hoisted_325 = { class: "flex md2" }
const _hoisted_326 = {
  key: 0,
  class: "va-table-responsive"
}
const _hoisted_327 = {
  class: "va-table va-table--hoverable",
  style: {"width":"100%"}
}
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævnerække"),
    /*#__PURE__*/_createElementVNode("th", null, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Point"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Fjern")
  ])
], -1))
const _hoisted_329 = { class: "center" }
const _hoisted_330 = { class: "row justify--center" }
const _hoisted_331 = { class: "flex md4" }
const _hoisted_332 = { class: "flex md4" }
const _hoisted_333 = { class: "flex md4" }
const _hoisted_334 = { class: "row justify--center" }
const _hoisted_335 = { class: "flex md4" }
const _hoisted_336 = { class: "flex md4 center" }
const _hoisted_337 = { class: "flex md4 center" }
const _hoisted_338 = /*#__PURE__*/_createTextVNode("Tilføj resultat")
const _hoisted_339 = { class: "layout gutter--lg" }
const _hoisted_340 = { class: "row justify--space-around" }
const _hoisted_341 = { class: "flex" }
const _hoisted_342 = { class: "flex" }
const _hoisted_343 = /*#__PURE__*/_createTextVNode("Opdater stævne")
const _hoisted_344 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_345 = /*#__PURE__*/_createTextVNode("Opret resultater")
const _hoisted_346 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 mt-2 center" }, "Alle tilgængelige rækker", -1))
const _hoisted_348 = { class: "va-table-responsive" }
const _hoisted_349 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_350 = { key: 0 }
const _hoisted_351 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_vue_csv_toggle_headers = _resolveComponent("vue-csv-toggle-headers")!
  const _component_vue_csv_errors = _resolveComponent("vue-csv-errors")!
  const _component_vue_csv_input = _resolveComponent("vue-csv-input")!
  const _component_vue_csv_map = _resolveComponent("vue-csv-map")!
  const _component_vue_csv_import = _resolveComponent("vue-csv-import")!
  const _component_va_button_toggle = _resolveComponent("va-button-toggle")!
  const _component_va_progress_circle = _resolveComponent("va-progress-circle")!
  const _component_va_radio = _resolveComponent("va-radio")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_badge = _resolveComponent("va-badge")!
  const _component_it_drawer = _resolveComponent("it-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger stævner', 'Vis stævnerækker og stævner', 'Vis og rediger ranglistepoints', 'Opret ny stævnerække', 'Vis og rediger stævnetilmeldinger', 'Vis og juster stævneresultater'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.retrieveVariousData()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.competitionColumnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.competitionSearchInputValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.competitionSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.findCompetition()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.findCompetition()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              label: "Stævne status",
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue2,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterStatusStringValue2) = $event)),
              options: _ctx.filterStatusStringOptions2,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_select, {
              label: "Stævne afvikling",
              modelValue: _ctx.filterCompetitionByTimeValue,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterCompetitionByTimeValue) = $event)),
              options: _ctx.filterCompetitionByTimeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.newCompetition()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.competitionColumnSort('name')))
                    }, "Navn"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.competitionColumnSort('place')))
                    }, "Spillested"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.competitionColumnSort('start')))
                    }, "Starter den"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.competitionColumnSort('end')))
                    }, "Slutter den"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.competitionColumnSort('lastRegistration')))
                    }, "Sidste tilmelding den"),
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staevners, (staevne, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: Number(staevne.id)
                  }, [
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(staevne.id), 9, _hoisted_20),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, _toDisplayString(staevne.staevne_navn), 9, _hoisted_21),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, _toDisplayString(_ctx.convertHTMLToTextShort(staevne.staevne_spillested)), 9, _hoisted_22),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, [
                      _createTextVNode(_toDisplayString((staevne.staevne_start !== null && staevne.staevne_start?.length >= 1 ? _ctx.danishDataWClockArr(_ctx.locConvertFromUTCtoLocalDateTime(staevne.staevne_start))[0] : '-')), 1),
                      _hoisted_24,
                      _createTextVNode(_toDisplayString('kl. ' + (staevne.staevne_start !== null && staevne.staevne_start?.length >= 1 ? _ctx.danishDataWClockArr(_ctx.locConvertFromUTCtoLocalDateTime(staevne.staevne_start))[1] : '-')), 1)
                    ], 8, _hoisted_23),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString((new Date(staevne.staevne_slut)).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit' }).replaceAll('.', '/')), 9, _hoisted_25),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString((new Date(staevne.staevne_sidstetilmelding)).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit'}).replaceAll('.', '/')), 9, _hoisted_26),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(staevne?.staevne_raekker_id?.length), 9, _hoisted_27),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, {
                        outline: "",
                        "text-color": "primary",
                        rounded: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            name: "editcompetitionresults",
                            onClick: ($event: any) => (_ctx.editCompetitionResults(Number(staevne.id), staevne.documentId)),
                            style: {"border":"1px solid rgb(21, 78, 193)"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_28),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "editcompetition",
                            onClick: ($event: any) => (_ctx.editCompetition(Number(staevne.id), staevne.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: staevne.staevne_status ? 'check_box' : 'check_box_outline_blank',
                            color: staevne.staevne_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuschangecompetition",
                            onClick: ($event: any) => (_ctx.statusCompetition(Number(staevne.id), staevne.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(staevne?.staevne_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"]),
                          _createVNode(_component_va_button, {
                            color: "danger",
                            class: "btn",
                            name: "deletecompetition",
                            onClick: ($event: any) => (_ctx.deleteCompetitionWarning(Number(staevne.id), staevne.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_32
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_30)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_34,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.jumpToPage(_ctx.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_35, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_36, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
          }),
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.competitionModal,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.competitionModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_va_button, {
                  class: "btn mr-2",
                  color: "success",
                  onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.$refs.competitionForm.validate() ? (_ctx.createNewCompetition ? _ctx.createCompetition() : _ctx.updateCompetition()) : _ctx.$Message.warning({ text: 'Fejl: Et felt eller flere felter er ikke udfyldt korrekt' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.createNewCompetition ? 'Opret stævne' : 'Gem'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn ml-2",
                  color: "secondary",
                  onClick: _cache[43] || (_cache[43] = ($event: any) => {(_ctx.clearCompetitionValues(true)); _ctx.$Message.warning({ text: _ctx.createNewCompetition ? 'Oprettelsen af stævne blev annulleret' : 'Redigeringen blev annulleret' })})
                }, {
                  default: _withCtx(() => [
                    _hoisted_84
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_39, _toDisplayString(_ctx.createNewCompetition ? 'Opret nyt stævne' : 'Rediger stævne'), 1),
            _createVNode(_component_va_form, {
              ref: "competitionForm",
              onValidation: _cache[41] || (_cache[41] = ($event: any) => (_ctx.validation = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card, {
                  color: "#afcfff",
                  gradient: true,
                  stripe: true,
                  "stripe-color": "#2f5f4f"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                modelValue: _ctx.competitionData.competitionName,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.competitionData.competitionName) = $event)),
                                type: "text",
                                label: "Stævnenavn",
                                rules: [(v) => v?.length >= 1 || 'Stævnenavnet mangler'],
                                placeholder: "Navn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_va_switch, {
                                modelValue: _ctx.competitionData.competitionStatus,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.competitionData.competitionStatus) = $event)),
                                color: "success",
                                "true-inner-label": "Aktiv",
                                "false-inner-label": "Inaktiv",
                                "left-label": "",
                                label: "Status:"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_va_switch, {
                                modelValue: _ctx.isEventRegistrationOpen,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isEventRegistrationOpen) = $event)),
                                color: "success",
                                "true-inner-label": "Open",
                                "false-inner-label": "Close",
                                "left-label": "",
                                label: "Registration:"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_va_select, {
                                class: "inputSizing",
                                modelValue: _ctx.competitionCategoryTitleValue,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.competitionCategoryTitleValue) = $event)),
                                options: _ctx.competitionCategoryTitleOptions,
                                label: "Kategori",
                                bordered: ""
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _withDirectives(_createVNode(_component_va_select, {
                                class: "inputSizing",
                                label: "Hvilket kategori 2 stævne er det?",
                                modelValue: _ctx.competitionRegionLimitValue,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.competitionRegionLimitValue) = $event)),
                                options: _ctx.competitionRegionLimitOptions,
                                bordered: ""
                              }, null, 8, ["modelValue", "options"]), [
                                [_vShow, _ctx.competitionCategoryTitleValue.toString() === 'kategori2']
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_va_input, {
                                "min-rows": 5,
                                class: "inputSizing",
                                type: "textarea",
                                modelValue: _ctx.competitionData.competitionVenueLocation,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.competitionData.competitionVenueLocation) = $event)),
                                label: "Spillested",
                                rules: [(v) => v?.length >= 1 || 'Spillestedets adresse mangler'],
                                placeholder: "Adresse",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              ((_ctx.competitionData.competitionInvitation !== null && _ctx.competitionData.competitionInvitation?.length > 0))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_52,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionData.competitionInvitation, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        class: "row invitationrow align-self--baseline mb-2"
                                      }, [
                                        _createElementVNode("div", _hoisted_53, [
                                          (index > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "competitionbutton",
                                                onClick: ($event: any) => (_ctx.moveInvitation(index, -1))
                                              }, [
                                                _createVNode(_component_va_icon, {
                                                  name: "keyboard_double_arrow_up",
                                                  color: "success"
                                                })
                                              ], 8, _hoisted_54))
                                            : _createCommentVNode("", true),
                                          ((index < _ctx.competitionData.competitionInvitation.length -1 || _ctx.competitionData.competitionInvitation?.length -1 > 1))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "competitionbutton",
                                                onClick: ($event: any) => (_ctx.moveInvitation(index, 1))
                                              }, [
                                                _createVNode(_component_va_icon, {
                                                  name: "keyboard_double_arrow_down",
                                                  color: "success"
                                                })
                                              ], 8, _hoisted_55))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_56, _toDisplayString(index+1 + '.'), 1),
                                        _createElementVNode("div", _hoisted_57, _toDisplayString(item.name), 1),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("button", {
                                            class: "competitionbutton",
                                            onClick: ($event: any) => (_ctx.removeInvitation(index))
                                          }, [
                                            _createVNode(_component_va_icon, {
                                              name: "clear",
                                              color: "danger"
                                            })
                                          ], 8, _hoisted_59)
                                        ])
                                      ]))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createVNode(_component_va_button, {
                                class: "center",
                                onClick: _ctx.addInvitation,
                                color: "success"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_60
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_component_va_input, {
                                class: "item",
                                modelValue: _ctx.competitionData.competitionPeriodBegin,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.competitionData.competitionPeriodBegin) = $event)),
                                type: "datetime-local",
                                label: "Stævnet starter den",
                                rules: [(v) => v?.length >= 1 || 'Starttidspunkt mangler'],
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_va_input, {
                                class: "item",
                                modelValue: _ctx.competitionData.competitionPeriodEnd,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.competitionData.competitionPeriodEnd) = $event)),
                                type: "datetime-local",
                                label: "Stævnet slutter den",
                                rules: [(v) => v?.length >= 1 || 'Sluttidspunkt mangler'],
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_component_va_input, {
                                class: "item",
                                modelValue: _ctx.competitionData.competitionRegistrationFrom,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.competitionData.competitionRegistrationFrom) = $event)),
                                type: "date",
                                label: "Tilmelding fra * ",
                                bordered: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_va_input, {
                                class: "item",
                                modelValue: _ctx.competitionData.competitionLastRegistrationDate,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.competitionData.competitionLastRegistrationDate) = $event)),
                                type: "date",
                                label: "Sidste tilmelding den *",
                                bordered: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_va_select, {
                                class: "item inputSizing",
                                label: "Arrangør klub",
                                modelValue: _ctx.competitionClubsNameValue,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.competitionClubsNameValue) = $event)),
                                options: _ctx.competitionClubsNameOptions,
                                "text-by": "name",
                                rules: [(v) => v.value !== 0 || 'Ingen klub er valgt'],
                                searchable: "",
                                "prevent-overflow": "",
                                bordered: ""
                              }, null, 8, ["modelValue", "options", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _createVNode(_component_va_select, {
                                class: "item inputSizing",
                                label: "Tilknyt produktgruppe",
                                modelValue: _ctx.productTypeValue,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.productTypeValue) = $event)),
                                options: _ctx.productTypeOptions,
                                "text-by": "name",
                                searchable: "",
                                rules: [(v) => v.value !== 0 || 'Ingen produktgruppe er tilknyttet' ],
                                "prevent-overflow": "",
                                bordered: ""
                              }, null, 8, ["modelValue", "options", "rules"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_va_input, {
                                class: "item inputSizing",
                                modelValue: _ctx.competitionData.competitionLeader,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.competitionData.competitionLeader) = $event)),
                                type: "text",
                                label: "Stævneleder",
                                rules: [(v) => v?.length >= 1 || 'Der mangler en stævneleder'],
                                placeholder: "Navn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_va_input, {
                                class: "item inputSizing",
                                modelValue: _ctx.competitionData.competitionUmpire,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.competitionData.competitionUmpire) = $event)),
                                type: "text",
                                label: "Overdommer",
                                rules: [(v) => v?.length >= 1 || 'Der mangler en overdommer'],
                                placeholder: "Navn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createVNode(_component_va_select, {
                                class: "item inputSizing",
                                label: "Tilknyt stævnerækker",
                                modelValue: _ctx.competitionRowsNameValue,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.competitionRowsNameValue) = $event)),
                                options: _ctx.competitionRowsNameOptions,
                                "text-by": "name",
                                multiple: "",
                                searchable: "",
                                rules: [(v) => v?.length >= 1 || 'Ingen stævnerækker tilknyttet'],
                                "prevent-overflow": "",
                                bordered: ""
                              }, null, 8, ["modelValue", "options", "rules"])
                            ])
                          ]),
                          ((_ctx.competitionRowsNameValue?.length > 0))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.competitionRowsNameValue, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "row justify--center align--center",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.getRowNameFromId(Number(item.value))), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_75, [
                                    _createVNode(_component_va_input, {
                                      type: "number",
                                      modelValue: item.price,
                                      "onUpdate:modelValue": ($event: any) => ((item.price) = $event),
                                      label: "Rækkepris",
                                      rules: [(v) => v?.toString() !== '' || 'Pris mangler']
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_76, [
                                    _createVNode(_component_va_select, {
                                      class: "item inputSizing",
                                      modelValue: _ctx.selectedEventsData[item.value],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.selectedEventsData[item.value]) = $event),
                                      label: "Select Tournament Events",
                                      options: _ctx.tournamentEventsOption,
                                      "track-by": (v) => v.id,
                                      "text-by": (v) => v.event_label,
                                      searchable: "",
                                      "prevent-overflow": "",
                                      bordered: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "track-by", "text-by"]),
                                    _createVNode(_component_va_button, {
                                      class: "btn mr-2",
                                      color: "success",
                                      disabled: !_ctx.selectedEventsData[item.value],
                                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.updateDartConnectEvents()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_77
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled"])
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createVNode(_component_va_select, {
                                class: "item inputSizing",
                                modelValue: _ctx.selectedTournamentOption,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.selectedTournamentOption) = $event)),
                                label: "Select Tournament",
                                options: _ctx.tournamentsOption,
                                "track-by": (v) => v.id,
                                "text-by": (v) => v.dctv_title,
                                searchable: "",
                                "prevent-overflow": "",
                                bordered: ""
                              }, null, 8, ["modelValue", "options", "track-by", "text-by"]),
                              _createVNode(_component_va_button, {
                                class: "btn mr-2",
                                color: "success",
                                disabled: _ctx.isSetDissable,
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setTournament()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_80
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ])
                          ]),
                          _hoisted_81
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteCompetitionWarningModal,
          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.deleteCompetitionWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.deleteCompetition(_ctx.deleteCompetitionId, _ctx.deleteCompetitionDocumentId)))
            }, {
              default: _withCtx(() => [
                _hoisted_86
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.deleteCompetitionWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_87
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_85
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.addInvitationModal,
          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.addInvitationModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.useSelectedInvitation()))
            }, {
              default: _withCtx(() => [
                _hoisted_95
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.cancelAddInvitation()))
            }, {
              default: _withCtx(() => [
                _hoisted_96
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "invitationcontainer",
                    key: media.id
                  }, [
                    _createElementVNode("label", _hoisted_90, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.selectedCompetitionInvitation) = $event)),
                        type: "radio",
                        color: "success",
                        id: index,
                        name: "choosenInvitation",
                        value: media
                      }, null, 8, _hoisted_91), [
                        [_vModelRadio, _ctx.selectedCompetitionInvitation]
                      ]),
                      _createTextVNode(" " + _toDisplayString(' ' + media.name), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_va_divider),
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("input", {
                  class: "mb-4",
                  type: "file",
                  onChange: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                }, null, 32),
                _createVNode(_component_va_button, {
                  class: "btn",
                  onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onUpload()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_94
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editCompetitionResultsModal,
          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.editCompetitionResultsModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": "",
          style: {"display":"flex","flex-direction":"column"}
        }, {
          footer: _withCtx(() => [
            _withDirectives(_createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[60] || (_cache[60] = ($event: any) => {_ctx.generateCompetitionResults(); _ctx.isFromCsv = true})
            }, {
              default: _withCtx(() => [
                _hoisted_142
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.editCompetitionResultsModalTabValue === '1']
            ]),
            _withDirectives(_createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[61] || (_cache[61] = ($event: any) => {_ctx.generateCompetitionResultsFromDartConnect(); _ctx.isFromDartConnect = true}),
              disabled: _ctx.isGenerateResultsDisabled
            }, {
              default: _withCtx(() => [
                _hoisted_143
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [_vShow, _ctx.editCompetitionResultsModalTabValue === '1']
            ]),
            _withDirectives(_createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.saveUpdateCompetitionResults())),
              disabled: !_ctx.isFromCsv
            }, {
              default: _withCtx(() => [
                _hoisted_144
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [_vShow, _ctx.editCompetitionResultsModalTabValue === '2']
            ]),
            _withDirectives(_createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[63] || (_cache[63] = ($event: any) => {_ctx.generateCompetitionResultsFromDartConnect(); _ctx.isFromDartConnect = true}),
              disabled: _ctx.isGenerateResultsDisabled
            }, {
              default: _withCtx(() => [
                _hoisted_145
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [_vShow, _ctx.editCompetitionResultsModalTabValue === '2']
            ]),
            _withDirectives(_createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.saveUpdateCompetitionResultsFromDartConnect())),
              disabled: !_ctx.isFromDartConnect
            }, {
              default: _withCtx(() => [
                _hoisted_146
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [_vShow, _ctx.editCompetitionResultsModalTabValue === '2']
            ]),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editCompetitionResultsModal = false), _ctx.cancelCompetitionResultsEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_147
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("p", _hoisted_99, "Oplysninger for stævne " + _toDisplayString(_ctx.competitionData.competitionName), 1)
              ]),
              _createVNode(_component_va_tabs, {
                modelValue: _ctx.editCompetitionResultsModalTabValue,
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.editCompetitionResultsModalTabValue) = $event)),
                grow: ""
              }, {
                tabs: _withCtx(() => [
                  _createVNode(_component_va_tab, {
                    label: "Vælg optioner",
                    name: "1",
                    key: "1",
                    grow: ""
                  }),
                  _createVNode(_component_va_tab, {
                    label: "Oversigt",
                    name: "2",
                    key: "2",
                    grow: "",
                    disabled: (_ctx.csvInputDataObj === undefined || _ctx.csvInputDataObj === null || _ctx.csvInputDataObj.length === 0)
                  }, null, 8, ["disabled"])
                ]),
                default: _withCtx(() => [
                  _hoisted_100,
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_va_switch, {
                          modelValue: _ctx.competitionResultsData.competitionResultsStatus,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.competitionResultsData.competitionResultsStatus) = $event)),
                          "true-inner-label": "Aktiv",
                          "false-inner-label": "Inaktiv",
                          class: "mr-4"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createVNode(_component_va_select, {
                          class: "mb-4 item",
                          label: "Spillerkategori",
                          modelValue: _ctx.competitionPlayerCategoryTitleValue,
                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.competitionPlayerCategoryTitleValue) = $event)),
                          options: _ctx.competitionPlayerCategoryTitleOptions,
                          "text-by": "name",
                          bordered: ""
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createVNode(_component_va_input, {
                          class: "mb-4 item",
                          modelValue: _ctx.competitionResultsData.competitionResultsDate,
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.competitionResultsData.competitionResultsDate) = $event)),
                          type: "date",
                          label: "Dato for resultater",
                          placeholder: "Dato",
                          bordered: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _hoisted_110,
                        _createVNode(_component_vue_csv_import, {
                          modelValue: _ctx.csvInputDataObj,
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.csvInputDataObj) = $event)),
                          fields: {place: {required: true, label: 'Place'}, navn: {required: true, label: 'Navn'}, clubcountry: {required: true, label: 'ClubCountry'}, licens: {required: true, label: 'Licens'}},
                          text: { errors: { fileRequired: 'En fil er påkrævet', invalidMimeType: 'Ugyldigt filtype' }, toggleHeaders: 'Filen har overskrifter', submitBtn: 'Indsend', fieldColumn: 'Felt', csvColumn: 'Kolonne' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_vue_csv_toggle_headers, { style: {"margin":"12px 12px"} }, {
                              default: _withCtx(({ hasHeaders, toggle }) => [
                                _createVNode(_component_va_switch, {
                                  modelValue: _ctx.csvInputUploadHasHeader,
                                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.csvInputUploadHasHeader) = $event)),
                                  onClick: _withModifiers(toggle, ["prevent"]),
                                  "true-inner-label": "Har overskrifter",
                                  "false-inner-label": "Har ingen overskrifter",
                                  class: "mr-4"
                                }, null, 8, ["modelValue", "onClick"]),
                                _createTextVNode(_toDisplayString(hasHeaders), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vue_csv_errors, { style: {"margin":"12px 12px"} }),
                            _createVNode(_component_vue_csv_input, {
                              name: "Vælg fil ...",
                              style: {"margin":"12px 12px"}
                            }),
                            _createVNode(_component_vue_csv_map, {
                              "auto-match": false,
                              style: {"margin":"12px 12px"}
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.editCompetitionResultsModalTabValue === '1']
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    (_ctx.csvInputDataObj.length > 0 && _ctx.isFromCsv)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                          _createElementVNode("table", _hoisted_112, [
                            _hoisted_113,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.csvInputDataObj, (csvInputDataObjRow, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: csvInputDataObjRow.place,
                                hidden: csvInputDataObjRow.memberactive === false
                              }, [
                                (csvInputDataObjRow.place === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      id: 'competitionresultstable-row' + (index+1),
                                      hidden: ""
                                    }, "-", 8, _hoisted_115))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      id: 'competitionresultstable-row' + (index+1),
                                      hidden: ""
                                    }, _toDisplayString(csvInputDataObjRow.place), 9, _hoisted_116)),
                                (csvInputDataObjRow.place === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 2,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, "-", 8, _hoisted_117))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 3,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, _toDisplayString(csvInputDataObjRow.place), 9, _hoisted_118)),
                                (csvInputDataObjRow.navn === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 4,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, "-", 8, _hoisted_119))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 5,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, _toDisplayString(csvInputDataObjRow.navn), 9, _hoisted_120)),
                                (csvInputDataObjRow.clubcountry === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 6,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, "-", 8, _hoisted_121))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 7,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, _toDisplayString(csvInputDataObjRow.clubcountry), 9, _hoisted_122)),
                                (csvInputDataObjRow.licens === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 8,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, "-", 8, _hoisted_123))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 9,
                                      id: 'competitionresultstable-row' + (index+1),
                                      class: "center"
                                    }, _toDisplayString(csvInputDataObjRow.licens), 9, _hoisted_124)),
                                (csvInputDataObjRow.points === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 10,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, "-", 8, _hoisted_125))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 11,
                                      id: 'competitionresultstable-row' + (index+1),
                                      class: "center"
                                    }, _toDisplayString(csvInputDataObjRow.points + csvInputDataObjRow.pointoffset), 9, _hoisted_126)),
                                (csvInputDataObjRow.place === undefined || csvInputDataObjRow.memberactive === false)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 12,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, null, 8, _hoisted_127))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 13,
                                      id: 'competitionresultstable-row' + (index+1)
                                    }, [
                                      _createVNode(_component_va_button_group, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_va_button, {
                                            class: "btn",
                                            color: "success",
                                            onClick: ($event: any) => (_ctx.reduceCompetitionResultPoints(index, Number(csvInputDataObjRow.place)))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_129
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_va_button, {
                                            class: "btn",
                                            color: "success",
                                            onClick: ($event: any) => (_ctx.restoreCompetitionResultPoints(index, Number(csvInputDataObjRow.place)))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_130
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_128))
                              ], 8, _hoisted_114))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tempCompetitionResultsData.length > 0 && _ctx.isFromDartConnect)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                          _createElementVNode("table", _hoisted_132, [
                            _hoisted_133,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempCompetitionResultsData, (resultDataObjRow, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                hidden: resultDataObjRow.memberactive === false
                              }, [
                                _createElementVNode("td", {
                                  id: 'competitionresultstable-row' + (index+1)
                                }, _toDisplayString(resultDataObjRow.place), 9, _hoisted_135),
                                _createElementVNode("td", {
                                  id: 'competitionresultstable-row' + (index+1)
                                }, _toDisplayString(resultDataObjRow.navn), 9, _hoisted_136),
                                _createElementVNode("td", {
                                  id: 'competitionresultstable-row' + (index+1),
                                  class: "center"
                                }, [
                                  _createVNode(_component_va_input, {
                                    class: "item",
                                    modelValue: _ctx.tempCompetitionResultsData[index].licens,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.tempCompetitionResultsData[index].licens) = $event),
                                    type: "number",
                                    label: "Licens",
                                    placeholder: "Licens No"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ], 8, _hoisted_137),
                                _createElementVNode("td", {
                                  id: 'competitionresultstable-row' + (index+1),
                                  class: "center"
                                }, _toDisplayString(resultDataObjRow.points + resultDataObjRow.pointoffset), 9, _hoisted_138),
                                _createElementVNode("td", {
                                  id: 'competitionresultstable-row' + (index+1)
                                }, [
                                  _createVNode(_component_va_button_group, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_va_button, {
                                        class: "btn",
                                        color: "success",
                                        onClick: ($event: any) => (_ctx.reduceCompetitionResultPointsOfDartConnect(index, Number(resultDataObjRow.place)))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_140
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_va_button, {
                                        class: "btn",
                                        color: "success",
                                        onClick: ($event: any) => (_ctx.restoreCompetitionResultPointsOfDartConnect(index, Number(resultDataObjRow.place)))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_141
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 8, _hoisted_139)
                              ], 8, _hoisted_134))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.editCompetitionResultsModalTabValue === '2']
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger stævner']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_148, [
        _createElementVNode("div", _hoisted_149, [
          _createElementVNode("div", _hoisted_150, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.competitionRowColumnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_151, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.competitionRowSearchInputValue,
              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.competitionRowSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[69] || (_cache[69] = _withKeys(($event: any) => (_ctx.findCompetitionRow()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.findCompetitionRow()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_152
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_153, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Filtrere efter status",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_select, {
                  class: "ml-4",
                  modelValue: _ctx.filterStatusStringValue,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
                  options: _ctx.filterStatusStringOptions,
                  bordered: "",
                  style: {"width":"75%"}
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_154, [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.retrieveAllSeries()))
            }, {
              default: _withCtx(() => [
                _hoisted_155
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_157, [
              _createElementVNode("table", _hoisted_158, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_159,
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.competitionRowColumnSort('rowName')))
                    }, "Stævnerækkenavn"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.competitionRowColumnSort('rowType')))
                    }, "Rækketype"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.competitionRowColumnSort('competitionCategory')))
                    }, "Stævnekategori"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.competitionRowColumnSort('competitionName')))
                    }, "Stævnenavn"),
                    _hoisted_160,
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.competitionRowColumnSort('begins')))
                    }, "Starter den"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.competitionRowColumnSort('ends')))
                    }, "Slutter den"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.competitionRowColumnSort('lastRegistration')))
                    }, "Sidste tilmelding den"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.competitionRowColumnSort('price')))
                    }, "Pris")
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionRowsRows, (competitionRowsRow, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: competitionRowsRow.id
                  }, [
                    _createElementVNode("td", {
                      id: 'competitionrowstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(competitionRowsRow.id), 9, _hoisted_161),
                    _createElementVNode("td", {
                      id: 'competitionrowstable-row' + (index+1)
                    }, _toDisplayString(competitionRowsRow.staevne_raekker_navn), 9, _hoisted_162),
                    (competitionRowsRow.staevne_raekker_type === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_163))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString((Number(competitionRowsRow.staevne_raekker_type) === 1 ? 'Double' : (Number(competitionRowsRow.staevne_raekker_type) === 2 ? 'Hold' : 'Single'))), 9, _hoisted_164)),
                    (competitionRowsRow.staevne_kategori === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 2,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_165))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString(competitionRowsRow.staevne_kategori), 9, _hoisted_166)),
                    (competitionRowsRow.staevne_navn === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 4,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_167))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 5,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString(competitionRowsRow.staevne_navn), 9, _hoisted_168)),
                    (competitionRowsRow.staevne_spillested === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 6,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString('-'), 8, _hoisted_169))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 7,
                          id: 'competitionrowstable-row' + (index+1)
                        }, _toDisplayString(_ctx.convertHTMLToTextShort(competitionRowsRow.staevne_spillested)), 9, _hoisted_170)),
                    (competitionRowsRow.staevne_start === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 8,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString('-'), 8, _hoisted_171))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 9,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString((new Date(competitionRowsRow.staevne_start)).toLocaleDateString('da-DK', { hour: 'numeric', minute: 'numeric' })), 9, _hoisted_172)),
                    (competitionRowsRow.staevne_slut === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 10,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString('-'), 8, _hoisted_173))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 11,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString((new Date(competitionRowsRow.staevne_slut)).toLocaleDateString('da-DK', { hour: 'numeric', minute: 'numeric' })), 9, _hoisted_174)),
                    (competitionRowsRow.staevne_sidstetilmelding === undefined)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 12,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString('-'), 8, _hoisted_175))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 13,
                          id: 'competitionrowstable-row' + (index+1),
                          class: "center"
                        }, _toDisplayString(competitionRowsRow.staevne_sidstetilmelding), 9, _hoisted_176)),
                    _createElementVNode("td", {
                      id: 'competitionrowstable-row' + (index+1),
                      class: "saldo center"
                    }, _toDisplayString(competitionRowsRow.staevne_raekker_tilmeldingsgebyr), 9, _hoisted_177)
                  ]))
                }), 128))
              ])
            ]))
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis stævnerækker og stævner']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_178, [
        _createElementVNode("div", _hoisted_179, [
          _createElementVNode("div", _hoisted_180, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Sorter efter"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button_toggle, {
                  size: "small",
                  rounded: false,
                  outline: "",
                  modelValue: _ctx.toggleIconsSortingValue3,
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.toggleIconsSortingValue3) = $event)),
                  options: [
                  { label: 'Placering', value: 'placering' },
                  { label: 'Kategori', value: 'kategori' },
                  { label: 'Points', value: 'points' },
                  { label: 'Række', value: 'raekke' }]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_181, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.competitionPointSearchInputValue,
              "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.competitionPointSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[83] || (_cache[83] = _withKeys(($event: any) => (_ctx.findCompetitionRankingsPoint()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.findCompetitionRankingsPoint()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_182
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_183, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Filtrere efter status",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_select, {
                  class: "ml-4",
                  modelValue: _ctx.filterStatusStringValue4,
                  "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.filterStatusStringValue4) = $event)),
                  options: _ctx.filterStatusStringOptions4,
                  bordered: "",
                  style: {"width":"75%"}
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_184, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_185, [
              _createElementVNode("table", _hoisted_186, [
                _hoisted_187,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staevneranglistepoints, (staevneranglistepoint, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: staevneranglistepoint.id
                  }, [
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(staevneranglistepoint.id), 9, _hoisted_188),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(staevneranglistepoint.staevne_ranglistepoint_placering), 9, _hoisted_189),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, _toDisplayString(staevneranglistepoint.staevne_ranglistepoint_kategori), 9, _hoisted_190),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(staevneranglistepoint.staevne_ranglistepoint_point), 9, _hoisted_191),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1),
                      class: "center"
                    }, _toDisplayString(staevneranglistepoint.staevne_ranglistepoint_raekke === null ? 'C' : (staevneranglistepoint.staevne_ranglistepoint_raekke === true ? 'A' : 'B')), 9, _hoisted_192),
                    _createElementVNode("td", {
                      id: 'competitionstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            color: "info",
                            class: "btn",
                            name: "editcompetition",
                            onClick: ($event: any) => (_ctx.editCompetitionRankingsPoint(staevneranglistepoint.id, staevneranglistepoint.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_194
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            icon: staevneranglistepoint.staevne_ranglistepoint_status ? 'check_box' : 'check_box_outline_blank',
                            color: staevneranglistepoint.staevne_ranglistepoint_status ? 'success' : 'rgb(255, 172, 10)',
                            class: "btn status-width",
                            name: "statuschangecompetitionrankingspoint",
                            onClick: ($event: any) => (_ctx.statusCompetitionRankingsPoint(staevneranglistepoint.id, staevneranglistepoint.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(staevneranglistepoint.staevne_ranglistepoint_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_193)
                  ]))
                }), 128))
              ])
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editCompetitionRankingsPointModal,
          "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.editCompetitionRankingsPointModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.updateCompetitionRankingsPoint()))
            }, {
              default: _withCtx(() => [
                _hoisted_203
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editCompetitionRankingsPointModal = false), _ctx.cancelCompetitionRankingsPointEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_204
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_195, [
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("p", _hoisted_197, "Oplysninger for stævne " + _toDisplayString(_ctx.competitionRankingsPointData.competitionPlacement), 1)
              ]),
              _createElementVNode("div", _hoisted_198, [
                _createElementVNode("div", _hoisted_199, [
                  _createVNode(_component_va_switch, {
                    modelValue: _ctx.competitionRankingsPointData.competitionRankingsPointStatus,
                    "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.competitionRankingsPointData.competitionRankingsPointStatus) = $event)),
                    "true-inner-label": "Aktiv",
                    "false-inner-label": "Inaktiv",
                    class: "mr-4"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_200, [
                _createElementVNode("div", _hoisted_201, [
                  _createVNode(_component_va_input, {
                    class: "mb-4 item",
                    modelValue: _ctx.competitionRankingsPointData.competitionRankingsPointPoint,
                    "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.competitionRankingsPointData.competitionRankingsPointPoint) = $event)),
                    type: "number",
                    label: "Antal point",
                    placeholder: "Antal",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_202, [
                  _createVNode(_component_va_select, {
                    class: "mb-4 item",
                    label: "Kategori",
                    modelValue: _ctx.competitionCategoryTitleValue,
                    "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.competitionCategoryTitleValue) = $event)),
                    options: _ctx.competitionCategoryTitleOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger ranglistepoints']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_205, [
        _createElementVNode("div", _hoisted_206, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_207, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_208, [
                (!_ctx.submitted2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                      _createElementVNode("div", _hoisted_210, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newcompetitionrow-form"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_211, [
                              _createElementVNode("div", _hoisted_212, [
                                _createElementVNode("div", _hoisted_213, [
                                  _createVNode(_component_va_switch, {
                                    modelValue: _ctx.competitionRowData.competitionRowStatus,
                                    "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.competitionRowData.competitionRowStatus) = $event)),
                                    "true-inner-label": "Aktiv",
                                    "false-inner-label": "Inaktiv",
                                    class: "mr-4"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_214, [
                                _createElementVNode("div", _hoisted_215, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.competitionRowData.competitionRowName,
                                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.competitionRowData.competitionRowName) = $event)),
                                    type: "text",
                                    label: "Rækkenavn",
                                    rules: [(competitionRowName) => _ctx.competitionRowData.competitionRowName.length > 1 || 'Stævnerækkenavnet mangler'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_216, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 center",
                                    modelValue: _ctx.competitionRowData.competitionRegistrationFee,
                                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.competitionRowData.competitionRegistrationFee) = $event)),
                                    type: "number",
                                    label: "Tilmeldingsgebyr",
                                    rules: [(competitionRegistrationFee) => _ctx.competitionRowData.competitionRegistrationFee.length > 1 || 'Stævnerækkegebyrbeløb mangler'],
                                    placeholder: "Beløb",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_217, [
                                _createElementVNode("div", _hoisted_218, [
                                  _createVNode(_component_va_select, {
                                    class: "mb-4",
                                    label: "Rækketype",
                                    modelValue: _ctx.competitionRowTypesNameValue,
                                    "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.competitionRowTypesNameValue) = $event)),
                                    options: _ctx.competitionRowTypesNameOptions,
                                    "text-by": "name",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_219, [
                                  _createVNode(_component_va_button, {
                                    color: "secondary",
                                    onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.retrieveAllSeries()))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_220
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _createElementVNode("div", _hoisted_221, [
                        _createElementVNode("div", _hoisted_222, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[97] || (_cache[97] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createCompetitionRow()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_223
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny stævnerække']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_224, [
        _createElementVNode("div", _hoisted_225, [
          _createElementVNode("div", _hoisted_226, [
            _createVNode(_component_va_select, {
              label: "Stævne",
              modelValue: _ctx.filterRegistrationByCompetitionsValue,
              "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.filterRegistrationByCompetitionsValue) = $event)),
              options: _ctx.filterRegistrationByCompetitionsOptions,
              bordered: "",
              "text-by": (filterRegistrationByCompetitionsOptions) => filterRegistrationByCompetitionsOptions.name,
              "track-by": (filterRegistrationByCompetitionsOptions) => filterRegistrationByCompetitionsOptions.id,
              searchable: ""
            }, null, 8, ["modelValue", "options", "text-by", "track-by"])
          ]),
          _createElementVNode("div", _hoisted_227, [
            _createVNode(_component_va_select, {
              disabled: _ctx.filterRegistrationByCompetitionsValue.id === '0',
              label: "Stævnerække",
              modelValue: _ctx.filterRegistrationsBySeriesValue,
              "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.filterRegistrationsBySeriesValue) = $event)),
              options: _ctx.filterRegistrationBySeriesOptions,
              "text-by": (filterRegistrationBySeriesOptions) => filterRegistrationBySeriesOptions.name,
              "track-by": (filterRegistrationBySeriesOptions) => filterRegistrationBySeriesOptions.id,
              bordered: "",
              searchable: ""
            }, null, 8, ["disabled", "modelValue", "options", "text-by", "track-by"])
          ]),
          _createElementVNode("div", _hoisted_228, [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.editPlayerRegistration()))
            }, {
              default: _withCtx(() => [
                _hoisted_229
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_230, [
            (!_ctx.exportLoader)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.retrieveExportData()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_231
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.exportLoader)
              ? (_openBlock(), _createBlock(_component_va_progress_circle, {
                  key: 1,
                  indeterminate: "",
                  modelValue: _ctx.exportLoader,
                  "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.exportLoader) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_232, [
            _createVNode(_component_va_button, {
              onClick: _cache[103] || (_cache[103] = ($event: any) => (_ctx.exportDartConnect()))
            }, {
              default: _withCtx(() => [
                _hoisted_233
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_234, [
            _createVNode(_component_va_button, {
              onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.registerPlayersForTheTournament())),
              disabled: _ctx.isDissabledRegisterDCPlayers
            }, {
              default: _withCtx(() => [
                _hoisted_235
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_236, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_237, [
              (_ctx.filterRegistrationByCompetitionsValue.id !== '0')
                ? (_openBlock(), _createElementBlock("table", _hoisted_238, [
                    _hoisted_239,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredStaevnetilmeldings, (staevnetilmelding, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: staevnetilmelding.id
                      }, [
                        _createElementVNode("td", {
                          id: 'competitionregistrationstable-row' + (index+1),
                          hidden: ""
                        }, _toDisplayString(staevnetilmelding.id), 9, _hoisted_240),
                        _createElementVNode("td", {
                          id: 'competitionregistrationstable-row' + (index+1),
                          class: "center"
                        }, [
                          _createVNode(_component_va_icon, {
                            name: staevnetilmelding.staevne_tilmelding_status ? 'check_box': 'check_box_outline_blank',
                            color: staevnetilmelding.staevne_tilmelding_status ? 'primary' : 'rgb(255, 172, 10)'
                          }, null, 8, ["name", "color"])
                        ], 8, _hoisted_241),
                        _createElementVNode("td", {
                          id: 'competitionregistrationstable-row' + (index+1)
                        }, _toDisplayString(_ctx.getTextOfMembersFromObject(staevnetilmelding.medlem_id, staevnetilmelding.usp_id)), 9, _hoisted_242),
                        _createElementVNode("td", {
                          id: 'competitionregistrationstable-row' + (index+1)
                        }, _toDisplayString(staevnetilmelding.staevne_raekker_id.staevne_raekker_navn), 9, _hoisted_243),
                        _createElementVNode("td", {
                          id: 'competitionregistrationstable-row' + (index+1)
                        }, [
                          _createVNode(_component_va_button, {
                            color: "danger",
                            onClick: ($event: any) => (_ctx.deleteRegistrationWarning(staevnetilmelding.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_245
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 8, _hoisted_244)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteRegistrationWarningModal,
          "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.deleteRegistrationWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.deleteRegistration(this.deleteRegistrationId), _ctx.$Message.success({ text: 'Tilmeldingen er slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_247
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.deleteRegistrationWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_248
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_246
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editRegistrationModal,
          "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.editRegistrationModal) = $event)),
          size: "large",
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            (_ctx.competitionMemberRegistrationData.competitionMemberRegistrationAddRemoveStatus)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  class: "btn mr-4",
                  color: "success",
                  onClick: _cache[114] || (_cache[114] = ($event: any) => (_ctx.updateCompetitionMemberRegistrationEdit() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' + (_ctx.checkPlayerRestrictionsFlag > 0 ? ' ' + _ctx.getPlayerRegistrationCheckFlagMsg() : '' ) })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_275
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  class: "btn mr-4",
                  color: "danger",
                  onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.updateCompetitionMemberRegistrationEdit() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' + (_ctx.checkPlayerRestrictionsFlag > 0 ? ' ' + _ctx.getPlayerRegistrationCheckFlagMsg() : '' ) })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_276
                  ]),
                  _: 1
                })),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.updateCompetitionMemberRegistrationModal = false), _ctx.cancelUpdateCompetitionMemberRegistrationEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_277
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_249,
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_250, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_251, [
              _createElementVNode("div", _hoisted_252, [
                _createElementVNode("div", _hoisted_253, [
                  _createVNode(_component_va_switch, {
                    modelValue: _ctx.competitionMemberRegistrationData.competitionMemberRegistrationStatus,
                    "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.competitionMemberRegistrationData.competitionMemberRegistrationStatus) = $event)),
                    color: "success",
                    "true-inner-label": "Aktiv",
                    "false-inner-label": "Inaktiv"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_254, [
                  _createVNode(_component_va_select, {
                    label: "Vælg stævnerække",
                    modelValue: _ctx.competitionRowForMemberRegistrationNameValue,
                    "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.competitionRowForMemberRegistrationNameValue) = $event)),
                    options: _ctx.competitionRowForMemberRegistrationNameOptions,
                    "text-by": "name",
                    searchable: "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_255, [
                _createElementVNode("div", _hoisted_256, [
                  (_ctx.competitionRowForMemberRegistrationNameValue.name === '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_257, _hoisted_259))
                    : (_openBlock(), _createElementBlock("div", _hoisted_260, [
                        (_ctx.competitionMemberForMemberRegistrationNameMaxSelections < 2)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_261, "Ret stævnetilmeldingsoplysninger for en spiller"))
                          : (_openBlock(), _createElementBlock("p", _hoisted_262, "Ret stævnetilmeldingsoplysninger for flere spillere"))
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_263, [
                _createElementVNode("div", _hoisted_264, [
                  _createVNode(_component_va_switch, {
                    color: "success",
                    disabled: _ctx.competitionRowForMemberRegistrationNameValue.name === '',
                    modelValue: _ctx.competitionMemberRegistrationData.competitionMemberRegistrationAddRemoveStatus,
                    "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.competitionMemberRegistrationData.competitionMemberRegistrationAddRemoveStatus) = $event)),
                    "true-inner-label": "Tilføj tilmelding",
                    "false-inner-label": "Fjern tilmelding"
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createElementVNode("div", {
                  class: "flex md8",
                  hidden: _ctx.competitionPlayerDisregardForeignPlayers
                }, [
                  _hoisted_266,
                  (_ctx.competitionMemberRegistrationData.competitionMemberRegistrationAddRemoveStatus)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_267, "tilmeldes"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_268, "fjernes")),
                  _hoisted_269,
                  _hoisted_270,
                  _hoisted_271,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionPlayerModusOptions, (competitionPlayerModusOption, index) => {
                    return (_openBlock(), _createBlock(_component_va_radio, {
                      key: index,
                      modelValue: _ctx.competitionPlayerModusSelectedOption,
                      "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.competitionPlayerModusSelectedOption) = $event)),
                      option: competitionPlayerModusOption,
                      label: _ctx.competitionPlayerModusLabels[index],
                      disabled: (_ctx.competitionPlayerDisregardForeignPlayers) || (_ctx.competitionRowForMemberRegistrationNameValue.name === '')
                    }, null, 8, ["modelValue", "option", "label", "disabled"]))
                  }), 128))
                ], 8, _hoisted_265)
              ]),
              _createElementVNode("div", _hoisted_272, [
                _createElementVNode("div", _hoisted_273, [
                  (_ctx.showPlayerSelectionOptions)
                    ? (_openBlock(), _createBlock(_component_va_select, {
                        key: 0,
                        label: "Vælg medlem",
                        modelValue: _ctx.competitionMemberForMemberRegistrationNameValue,
                        "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.competitionMemberForMemberRegistrationNameValue) = $event)),
                        options: _ctx.competitionMemberForMemberRegistrationNameOptions,
                        "text-by": "name",
                        searchable: "",
                        multiple: "",
                        "max-selections": _ctx.competitionMemberForMemberRegistrationNameMaxSelections,
                        disabled: (Number(_ctx.competitionPlayerModusSelectedOption) > 1 || (Number(_ctx.competitionPlayerModusSelectedOption) === 1 && _ctx.competitionPlayerForMemberRegistrationNameMaxSelections < 2)) || (_ctx.competitionRowForMemberRegistrationNameValue.name === ''),
                        bordered: ""
                      }, null, 8, ["modelValue", "options", "max-selections", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_274, [
                  (_ctx.showPlayerSelectionOptions)
                    ? (_openBlock(), _createBlock(_component_va_select, {
                        key: 0,
                        label: "Vælg udenlandsk spiller",
                        modelValue: _ctx.competitionForeignPlayerForMemberRegistrationNameValue,
                        "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.competitionForeignPlayerForMemberRegistrationNameValue) = $event)),
                        options: _ctx.competitionForeignPlayerForMemberRegistrationNameOptions,
                        "text-by": "name",
                        searchable: "",
                        multiple: "",
                        "max-selections": _ctx.competitionForeignPlayerForMemberRegistrationNameMaxSelections,
                        disabled: (_ctx.competitionPlayerDisregardForeignPlayers || Number(_ctx.competitionPlayerModusSelectedOption) === 0) || (_ctx.competitionRowForMemberRegistrationNameValue.name === ''),
                        hidden: _ctx.competitionPlayerDisregardForeignPlayers,
                        bordered: ""
                      }, null, 8, ["modelValue", "options", "max-selections", "disabled", "hidden"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger stævnetilmeldinger']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_278, [
        _createElementVNode("div", _hoisted_279, [
          _createElementVNode("div", _hoisted_280, [
            _createVNode(_component_va_select, {
              label: "Vælg stævne",
              modelValue: _ctx.filterCompetitionNameValue,
              "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.filterCompetitionNameValue) = $event)),
              options: _ctx.filterCompetitionNameOptions,
              "text-by": "name",
              searchable: "",
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_281, [
            _createVNode(_component_va_select, {
              disabled: _ctx.filterCompetitionNameValue.value === '0',
              label: "Vælg række",
              modelValue: _ctx.filterCompetitionRowValue,
              "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.filterCompetitionRowValue) = $event)),
              options: _ctx.filterCompetitionRowOptions,
              "text-by": "name",
              "track-by": "id",
              searchable: "",
              bordered: ""
            }, null, 8, ["disabled", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_282, [
            _createVNode(_component_va_select, {
              label: "Resultater fra",
              options: _ctx.historicalCompetitionResultsOptions,
              modelValue: _ctx.historicalCompetitionResultsValue,
              "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.historicalCompetitionResultsValue) = $event)),
              searchable: "",
              bordered: ""
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_283, [
            _createVNode(_component_va_button, {
              onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.addForeignResults()))
            }, {
              default: _withCtx(() => [
                _hoisted_284
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_285, [
          _createElementVNode("div", _hoisted_286, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.foreignCompetitionResults,
              "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((_ctx.foreignCompetitionResults) = $event)),
              label: "Se resultater fra udenlandske stævner"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_287, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_288, [
              _createElementVNode("table", _hoisted_289, [
                _hoisted_290,
                (!_ctx.foreignCompetitionResults)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_291, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staevneresultats, (staevneresultat, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: staevneresultat.id
                        }, [
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center",
                            hidden: ""
                          }, _toDisplayString(staevneresultat?.id), 9, _hoisted_292),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(staevneresultat.staevne_resultater_placering), 9, _hoisted_293),
                          (staevneresultat.medlem_id === undefined || staevneresultat.medlem_id === null || staevneresultat.medlem_id.id === null || staevneresultat.medlem_id.user_id === null)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                id: 'competitionresultstable-row' + (index+1)
                              }, "-", 8, _hoisted_294))
                            : (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                id: 'competitionresultstable-row' + (index+1)
                              }, _toDisplayString(_ctx.getUserNameFromCompetitionResultsUsers(staevneresultat.medlem_id.user_id, staevneresultat.staevne_resultater_navn, (staevneresultat.medlem_id.id === _ctx.idOfGenericMember)) + ' [' + staevneresultat.medlem_id.medlem_licens + ']'), 9, _hoisted_295)),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1)
                          }, _toDisplayString(staevneresultat?.staevner_id?.staevne_navn), 9, _hoisted_296),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1)
                          }, _toDisplayString(staevneresultat.staevne_raekker_id.staevne_raekker_navn), 9, _hoisted_297),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(new Date(staevneresultat.staevne_resultater_dato).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit' })), 9, _hoisted_298),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(staevneresultat.staevne_ranglistepoint), 9, _hoisted_299),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, [
                            _createVNode(_component_va_button_group, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_va_button, {
                                  class: "btn",
                                  color: "success",
                                  onClick: ($event: any) => (_ctx.reduceCompetitionResultPointsInResultList(index, staevneresultat.id))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_301
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_va_button, {
                                  class: "btn",
                                  color: "success",
                                  onClick: ($event: any) => (_ctx.restoreCompetitionResultPointsInResultList(index, staevneresultat.id))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_302
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_300)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_303, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.udStaevneresultats, (resultat, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: resultat.id
                        }, [
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center",
                            hidden: ""
                          }, _toDisplayString(resultat.id), 9, _hoisted_304),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(resultat.ud_resultat_placering), 9, _hoisted_305),
                          (resultat.medlem_id === undefined || resultat.medlem_id === null || resultat.medlem_id.id === null || resultat.medlem_id.user_id === null)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                id: 'competitionresultstable-row' + (index+1)
                              }, "-", 8, _hoisted_306))
                            : (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                id: 'competitionresultstable-row' + (index+1)
                              }, _toDisplayString(_ctx.getUserNameFromCompetitionResultsUsers(resultat.medlem_id.user_id) + ' [' + resultat.medlem_id.medlem_licens + ']'), 9, _hoisted_307)),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1)
                          }, _toDisplayString(resultat?.ud_staevner_id?.ud_staevne_navn), 9, _hoisted_308),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1)
                          }, _toDisplayString(resultat.staevne_raekker_id.staevne_raekker_navn), 9, _hoisted_309),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(new Date(resultat.ud_resultat_dato).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit' })), 9, _hoisted_310),
                          _createElementVNode("td", {
                            id: 'competitionresultstable-row' + (index+1),
                            class: "center"
                          }, _toDisplayString(resultat.ud_resultat_ranglistepoint), 9, _hoisted_311),
                          _createElementVNode("td", _hoisted_312, [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "danger",
                              onClick: ($event: any) => (_ctx.deleteResultWarning(resultat.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_313
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ]))
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og juster stævneresultater']
      ])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.deleteResultWarningModal,
      "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.deleteResultWarningModal) = $event)),
      size: "small",
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "danger",
          onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.deleteForeignResult(this.foreignResultId), _ctx.$Message.success({ text: 'Resultatet er blevet slettet'})))
        }, {
          default: _withCtx(() => [
            _hoisted_315
          ]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "secondary",
          onClick: _cache[124] || (_cache[124] = ($event: any) => (_ctx.deleteResultWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
        }, {
          default: _withCtx(() => [
            _hoisted_316
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_314
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.foreignCompetitionResultsModal,
      "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => ((_ctx.foreignCompetitionResultsModal) = $event)),
      size: "large",
      "overlay-opacity": "0.5",
      "hide-default-actions": "",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "success",
          onClick: _cache[145] || (_cache[145] = ($event: any) => (_ctx.createForeignResults()))
        }, {
          default: _withCtx(() => [
            _hoisted_345
          ]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "secondary",
          onClick: _cache[146] || (_cache[146] = ($event: any) => (_ctx.$Message.warning({ text: 'Annulleret' }), (_ctx.foreignCompetitionResultsModal = false), _ctx.emptyForeignResultsDataFields()))
        }, {
          default: _withCtx(() => [
            _hoisted_346
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_317, [
          _hoisted_318,
          _createElementVNode("div", _hoisted_319, [
            _createElementVNode("div", _hoisted_320, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.foreignPlayerCompetitionData.foreignCompetitionName,
                "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.foreignPlayerCompetitionData.foreignCompetitionName) = $event)),
                type: "text",
                label: "Stævnenavn",
                readonly: _ctx.existingForeignCompetition
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_321, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.foreignPlayerCompetitionData.foreignCompetitionDate,
                "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((_ctx.foreignPlayerCompetitionData.foreignCompetitionDate) = $event)),
                type: "date",
                label: "Stævnedato",
                readonly: _ctx.existingForeignCompetition
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_322, [
              _createVNode(_component_va_checkbox, {
                modelValue: _ctx.existingForeignCompetition,
                "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.existingForeignCompetition) = $event)),
                label: "Eller vælg et stævne fra listen"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_323, [
            _createElementVNode("div", _hoisted_324, [
              _createVNode(_component_va_select, {
                disabled: !_ctx.existingForeignCompetition,
                modelValue: _ctx.foreignCompetitionValue,
                "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.foreignCompetitionValue) = $event)),
                options: _ctx.foreignCompetitionOptions,
                "text-by": (v) => v.name,
                "track-by": (v) => v.id,
                bordered: "",
                searchable: ""
              }, null, 8, ["disabled", "modelValue", "options", "text-by", "track-by"])
            ]),
            _createElementVNode("div", _hoisted_325, [
              _withDirectives(_createVNode(_component_va_button, {
                color: "success",
                onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx.editForeignCompetition(_ctx.foreignCompetitionValue.id)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, { name: "edit" })
                ]),
                _: 1
              }, 512), [
                [_vShow, (_ctx.foreignCompetitionValue.id !== 0 && _ctx.existingForeignCompetition)]
              ])
            ])
          ]),
          (_ctx.foreignCompetitionResultsArray.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_326, [
                _createElementVNode("table", _hoisted_327, [
                  _hoisted_328,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foreignCompetitionResultsArray, (result, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: result.numberInArray
                      }, [
                        _createElementVNode("td", null, _toDisplayString(result.name), 1),
                        _createElementVNode("td", null, _toDisplayString(result.date), 1),
                        _createElementVNode("td", null, _toDisplayString(result.rowName), 1),
                        _createElementVNode("td", null, _toDisplayString(result.placement), 1),
                        _createElementVNode("td", null, _toDisplayString(result.points), 1),
                        _createElementVNode("td", _hoisted_329, [
                          _createVNode(_component_va_badge, {
                            color: "danger",
                            class: "removeresultbutton",
                            text: "X",
                            onClick: ($event: any) => (_ctx.removeResult(index))
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_330, [
            _createElementVNode("div", _hoisted_331, [
              _createVNode(_component_va_select, {
                label: "Medlem",
                options: _ctx.findMemberOptions,
                modelValue: _ctx.findMemberValue,
                "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.findMemberValue) = $event)),
                "text-by": (v) => v.name,
                "track-by": (v) => v.id,
                onClick: _cache[132] || (_cache[132] = ($event: any) => (_ctx.clearInput())),
                onKeydown: _cache[133] || (_cache[133] = event => { _ctx.backSpace = event.key }),
                onKeypress: _cache[134] || (_cache[134] = e => { _ctx.memberSearchInputString += e.key }),
                searchable: "",
                bordered: ""
              }, null, 8, ["options", "modelValue", "text-by", "track-by"])
            ]),
            _createElementVNode("div", _hoisted_332, [
              _createVNode(_component_va_select, {
                label: "Stævnerække",
                modelValue: _ctx.foreignCompetitionRowsValue,
                "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event: any) => ((_ctx.foreignCompetitionRowsValue) = $event)),
                options: _ctx.foreignCompetitionRowsOptions,
                "text-by": (v) => v.name,
                "track-by": (v) => v.id,
                bordered: "",
                searchable: ""
              }, null, 8, ["modelValue", "options", "text-by", "track-by"])
            ]),
            _createElementVNode("div", _hoisted_333, [
              _createVNode(_component_va_input, {
                type: "date",
                modelValue: _ctx.foreignCompetitionDate,
                "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.foreignCompetitionDate) = $event)),
                label: "Dato for resultat"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_334, [
            _createElementVNode("div", _hoisted_335, [
              _createVNode(_component_va_select, {
                label: "Placering",
                modelValue: _ctx.foreignCompetitionRankingValue,
                "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event: any) => ((_ctx.foreignCompetitionRankingValue) = $event)),
                options: _ctx.foreignCompetitionRankingOptions,
                "text-by": (v) => v.placement,
                "track-by": (v) => v.index,
                searchable: "",
                bordered: ""
              }, null, 8, ["modelValue", "options", "text-by", "track-by"])
            ]),
            _createElementVNode("div", _hoisted_336, [
              _createVNode(_component_va_input, {
                "input-class": "text--center",
                label: "Point",
                modelValue: _ctx.foreignCompetitionPoints,
                "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.foreignCompetitionPoints) = $event)),
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_337, [
              _createVNode(_component_va_button, {
                onClick: _cache[139] || (_cache[139] = ($event: any) => (_ctx.addResultsToArray())),
                color: "success"
              }, {
                default: _withCtx(() => [
                  _hoisted_338
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editForeignCompetitionModal,
          "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.editForeignCompetitionModal) = $event)),
          "overlay-opacity": "0.5",
          "hide-default-actions": "",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.updateForeignCompetition()))
            }, {
              default: _withCtx(() => [
                _hoisted_343
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[143] || (_cache[143] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editForeignCompetitionModal = false), _ctx.cancelForeignCompetitionEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_344
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_339, [
              _createElementVNode("div", _hoisted_340, [
                _createElementVNode("div", _hoisted_341, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.foreignPlayerCompetitionData.foreignCompetitionName,
                    "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.foreignPlayerCompetitionData.foreignCompetitionName) = $event)),
                    label: "Stævnenavn",
                    type: "text",
                    rules: [(v) => _ctx.foreignPlayerCompetitionData.foreignCompetitionName.length > 1 || 'Angiv et stævnenavn']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_342, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.foreignPlayerCompetitionData.foreignCompetitionDate,
                    "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.foreignPlayerCompetitionData.foreignCompetitionDate) = $event)),
                    lable: "Dato",
                    type: "date"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_drawer, {
      placement: "right",
      modelValue: _ctx.seriesDrawerRight,
      "onUpdate:modelValue": _cache[151] || (_cache[151] = ($event: any) => ((_ctx.seriesDrawerRight) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_347,
        _createElementVNode("div", _hoisted_348, [
          _createElementVNode("table", _hoisted_349, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[148] || (_cache[148] = ($event: any) => (_ctx.seriesSorting('seriesName')))
                }, "Række"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[149] || (_cache[149] = ($event: any) => (_ctx.seriesSorting('price')))
                }, "Pris"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[150] || (_cache[150] = ($event: any) => (_ctx.seriesSorting('type')))
                }, "Type")
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSeries, (series) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: series.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(series.staevne_raekker_navn), 1),
                  _createElementVNode("td", null, _toDisplayString((series.staevne_raekker_tilmeldingsgebyr === undefined ? '0' : series.staevne_raekker_tilmeldingsgebyr)), 1),
                  (series.staevne_raekker_type === undefined)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_350, _toDisplayString('-')))
                    : (_openBlock(), _createElementBlock("td", _hoisted_351, _toDisplayString((Number(series.staevne_raekker_type) === 1 ? 'Double' : (Number(series.staevne_raekker_type) === 2 ? 'Hold' : 'Single'))), 1))
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}